import {useQuery} from "@tanstack/react-query";
import {readPreviousPayment} from "../../../../../api/order/OrdersApi";
import {ordersDetailPtaInit} from "../state";
import {BasicSearchType} from "../../../../../types/common/basic";

type Props = {
    param: BasicSearchType & { newLEnduserValue: string, newShipmentId: string }
    enabled?: boolean
};

export const useReadPreviousPayment = ({param, enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPreviousPayment", param],
        queryFn: async () => await readPreviousPayment(param),
        select: (res) => res?.data.result ?? ordersDetailPtaInit,
        enabled: enabled
    });

    return {data};
};
